import AddIcon from 'assets/icons/add-outline-icon-black.svg';
import { ACCOUNT_AGREEMENTS_MAX_SIZE } from 'features/to/const';
import usePayto from 'features/to/hooks/payment/usePayto';
import usePaytoStore from 'features/to/hooks/payment/usePaytoStore';
import useLang from 'hooks/useLang';
import React from 'react';
import styled from 'styled-components';
import { paragraph500Mixin } from 'styles';

const AddAnotherAccountAgreement = () => {
  const { t } = useLang();
  const { paytoAccountsAgreement } = usePaytoStore();
  const { onShowAddPaytoAccountModal } = usePayto();

  const handleOnClick = () => {
    onShowAddPaytoAccountModal();
  };

  if (paytoAccountsAgreement?.length >= ACCOUNT_AGREEMENTS_MAX_SIZE)
    return null;
  return (
    <AddAnotherAccountAgreementStyled onClick={handleOnClick}>
      <GridItem>
        <AddIconStyled src={AddIcon} width={24} height={24} />
      </GridItem>
      <GridItem>
        <SubText>{t('label_add_another_payto_agreement')}</SubText>
      </GridItem>
    </AddAnotherAccountAgreementStyled>
  );
};

const AddAnotherAccountAgreementStyled = styled.div`
  display: grid;
  grid-template-columns: 24px calc(100% - 40px);
  grid-gap: 10px;
  width: 100%;
  height: 50px;
  padding: 10px;
  margin-bottom: 0px;
  border-bottom: 1px solid var(--ds-bg-2);
  background-color: transparent;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }
`;

const GridItem = styled.div`
  width: 100%;
  display: grid;
  align-items: center;
  justify-content: start;
  padding-left: 6px;

  &:nth-child(1) {
    justify-content: center;
    align-items: center;
  }
`;

const SubText = styled.p`
  ${paragraph500Mixin}
  text-align: left;
`;

const AddIconStyled = styled.img`
  margin-left: 2px;
`;

export default AddAnotherAccountAgreement;
